import { Hr_Race } from "@/graphql/gql/graphql";
import NumberFireVerdict from "../numberFireVerdict";
import RaceLegend from "./RaceLegend";
import RaceSelection from "./RaceSelection";
import ViewFilter from "./ViewFilter";
import styles from "./raceControls.module.scss";

interface RaceControlsProps {
  verdict: string | undefined;
  races: Hr_Race[];
}

const RaceControls = ({ verdict, races }: RaceControlsProps) => (
  <div>
    <div className={styles.container}>
      <div className={styles.controls}>
        <ViewFilter />
        <RaceSelection races={races} />
      </div>
      {verdict ? <NumberFireVerdict verdict={verdict} /> : ""}
    </div>
    <RaceLegend />
  </div>
);

export default RaceControls;
